import { useConfigContext } from "shared/contexts/ConfigContext";

import { VIADUCK_PAGE_CONFIG_KEY } from "pages/SuperAdmin/PagesConfig/types";

export const useViaduckEnabled = () => {
  const { pages } = useConfigContext();

  return Boolean(pages[VIADUCK_PAGE_CONFIG_KEY]);
};
